// ==== BOTÃO REMOVER ITEM ====
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const line = this.dataset.index;
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems) cartItems.updateQuantity(line, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

// ==== COMPONENTE PRINCIPAL DE ITENS ====
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((res) => res.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        }
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, Object.assign({}, fetchConfig(), { body }))
      .then((res) => res.text())
      .then((state) => {
        const parsed = JSON.parse(state);
        const quantityEl =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        if (parsed.errors) {
          if (quantityEl) quantityEl.value = quantityEl.getAttribute('value');
          this.updateLiveRegions(line, parsed.errors);
          return;
        }

        this.classList.toggle('is-empty', parsed.item_count === 0);
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', parsed.item_count === 0);

        this.getSectionsToRender().forEach((s) => {
          const el =
            document.getElementById(s.id).querySelector(s.selector) || document.getElementById(s.id);
          if (el) el.innerHTML = this.getSectionInnerHTML(parsed.sections[s.section], s.selector);
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsed, variantId });
      })
      .catch(() => {
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => this.disableLoading(line));
  }

  updateLiveRegions(line, message) {
    const lineError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineError) lineError.querySelector('.cart-item__error-text').innerHTML = message;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const container =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.add('cart__items--disabled');
  }

  disableLoading(line) {
    const container =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.remove('cart__items--disabled');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

// ==== DRAWER PRINCIPAL ====
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
const overlay = this.querySelector('#CartDrawer-Overlay');
if (overlay) overlay.addEventListener('click', this.close.bind(this));    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const note = this.querySelector('[id^="Details-"] summary');
    if (note && !note.hasAttribute('role')) this.setSummaryAccessibility(note);
    setTimeout(() => this.classList.add('animate', 'active'));

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.getSectionsToRender().forEach((s) => {
      const sectionEl = s.selector
        ? document.querySelector(s.selector)
        : document.getElementById(s.id);
      sectionEl.innerHTML = this.getSectionInnerHTML(parsedState.sections[s.id], s.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  setActiveElement(el) {
    this.activeElement = el;
  }
}

customElements.define('cart-drawer', CartDrawer);

// ==== EXTENSÃO PARA ITENS DENTRO DO DRAWER ====
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
